import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Table, Card, Link, Modal, Button, Label, Text, Pagination, Spin } from 'components/elements';
import Axios from 'axios';
import { BASE_URL, PAGE_SIZE } from '../../../inc/constants';
import { getAPIDefaultHeaders, handleCatch, handleEntityDelete } from '../../../inc/functions';
import { act } from 'react-dom/test-utils';

const MessageModal = ({active, onToggle, id}) => {
  const [obj, setObj] = useState();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if(!id) return;
    load();
  }, [id])
  
  const load = () => {
    setLoading(true);
    Axios.get(`${BASE_URL}/admin/messages/${id}/`, getAPIDefaultHeaders())
    .then(res => {
      setObj(res.data);
      setLoading(false);
    })
    .catch(err => {
      handleCatch(err);
      setLoading(false);
    });
  }

  return(
    <Modal active={active} onToggle={onToggle} title={obj?.subject}>
      <Spin active={loading}>
        <Text>
          <Label>نام کامل:</Label>
          {obj?.fullname}
        </Text>
        <Text>
          <Label>ایمیل:</Label>
          <Link href={`mailto:${obj?.email}`} target="_blank">
            {obj?.email}
          </Link>
        </Text>
        <Text>
          <Label>پیام:</Label>
          {obj?.message}
        </Text>
      </Spin>
    </Modal>
  )
}

const MessageList = ({ className }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [page, setPage] = useState(1);
  const [activeId, setActiveId] = useState();
  const columns = [
    {
      title: 'نام کامل',
      dataIndex: 'fullname',
    },
    {
      title: 'موضوع',
      dataIndex: 'subject',
    },
    {
      title: 'پیام',
      dataIndex: 'message',
      render: (d) => d && d.length > 20 ? d.substr(0, 20) + '...' : d,
    },
    {
      title: '',
      dataIndex: 'id',
      render: id => (
        <>
          <Button onClick={() => setActiveId(id)} small primary>نمایش</Button>
          <Button onClick={() => handleEntityDelete('messages', id, 'پیام', setLoading, load)} small error>حذف</Button>
        </>
      ),
    },
    
  ];
  useEffect(() => {
    load();
  }, [page]);

  const load = () => {
    setLoading(true);
    Axios.get(`${BASE_URL}/admin/messages/?page=${page}`, getAPIDefaultHeaders()).then((res) => {
      setData(res.data);
      setLoading(false);
    }).catch((err) => {
      handleCatch(err);
      setLoading(false);
    });
  };

  return (
    <>
      <MessageModal active={activeId ? true : false} id={activeId} onToggle={() => setActiveId(null)} />
      <Card title="پیام‌ها">
        <Spin active={loading}>
          <Table dataSource={data?.results || []} columns={columns} />
          <Pagination count={data?.count || 0} current={page} onChange={setPage}/>
        </Spin>
      </Card>
    </>
  );
};

export default MessageList;
